export function attachPageViewTracking(router, appInsights) {
    router.beforeEach(function (route, from, next) {
        appInsights.startTrackPage(route.name || route.fullPath);
        next();
    });
    router.afterEach(function (route) {
        appInsights.stopTrackPage(route.name || route.fullPath, route.fullPath);
    });
}
